export default function PrivacyPolicies() {
  return (
    <div className="p-6 md:mx-28 bg-gray-50 mt-5 space-y-4">
      <h1 className="text-3xl flex justify-center py-4 font-bold">AnsHR Privacy Policy</h1>

      <div>
        <p className="font-bold text-xl">1. Introduction and Scope</p><br />
        This Privacy Policy governs the collection, processing, and use of personal information by AnsHR (the "App"), a Human Resources Management System developed and operated by Educerns Technologies Private Limited ("Company," "we," "us," or "our"), a company incorporated under the laws of India.<br />
        By downloading, installing, accessing, or using the AnsHR application, you ("User," "you," or "your") acknowledge that you have read, understood, and agree to be bound by this Privacy Policy and our Terms of Service.<br />
        This Privacy Policy complies with applicable Indian data protection laws including the Information Technology Act, 2000, Information Technology (Reasonable Security Practices and Procedures and Sensitive Personal Data or Information) Rules, 2011, and the proposed Personal Data Protection Bill.<br />
        All data processing activities are conducted within the territory of India unless explicitly stated otherwise.
      </div>

      <div>
        <p className="font-bold text-xl">2. Information We Collect</p><br />
        We collect the following categories of information in compliance with Indian privacy laws:<br />
        A. PERSONAL INFORMATION<br />
        • Full name, employee ID, contact information (email, phone, address)<br />
        • Aadhaar number, PAN number, and other government-issued identification (as required by Indian employment laws)<br />
        • Emergency contact information and family details<br />
        • Date of birth, gender, nationality, marital status<br />
        • Profile photographs and identification documents<br />
        B. SENSITIVE PERSONAL DATA OR INFORMATION (SPDI)<br />
        • Bank account details and financial information for payroll<br />
        • Biometric information (fingerprint, facial recognition for attendance)<br />
        • Medical information and health records (if applicable)<br />
        • Password and authentication credentials<br />
        C. EMPLOYMENT INFORMATION<br />
        • Job title, department, reporting structure, grade/level<br />
        • Employment history, joining date, employment status<br />
        • Salary, compensation details, tax information (TDS, PF, ESI)<br />
        • Performance evaluations, appraisals, disciplinary records<br />
        • Training records, certifications, and skill assessments<br />
        • Provident Fund (PF) and Employee State Insurance (ESI) details<br />
        D. ATTENDANCE AND TIME DATA<br />
        • Clock-in/clock-out times, break periods<br />
        • Leave applications, vacation days, sick leave, casual leave<br />
        • Overtime hours, shift schedules, work-from-home logs<br />
        • Location data for attendance tracking (if GPS-based attendance is enabled)<br />
        E. DEVICE AND TECHNICAL INFORMATION<br />
        • Device identifiers (IMEI, Android ID, Device ID)<br />
        • IP addresses, operating system, device model<br />
        • App usage data, access logs, crash reports<br />
        • Network information and connection details<br />
        F. COMMUNICATIONS<br />
        • Internal messages, announcements, feedback within the app<br />
        • Support communications and service requests<br />
        • System notifications and alerts
      </div>

      <div>
        <p className="font-bold text-xl">3. Legal Basis and Purpose of Data Processing</p><br />
        We collect and process your personal information for the following lawful purposes under Indian law:<br />
        A. CONTRACTUAL OBLIGATIONS<br />
        • Managing employment relationships and HR processes<br />
        • Processing payroll, PF, ESI, and statutory benefits<br />
        • Attendance tracking and leave management<br />
        • Performance evaluation and career development<br />
        • Compliance with employment contracts<br />
        B. LEGAL AND STATUTORY COMPLIANCE<br />
        • Income Tax Act, 1961 (TDS, Form 16 generation)<br />
        • Provident Fund Act, 1952 (PF contributions and withdrawals)<br />
        • Employee State Insurance Act, 1948 (ESI contributions)<br />
        • Contract Labour Act, 1970 (if applicable)<br />
        • Factories Act, 1948 (attendance and working hours)<br />
        • Labour laws and employment regulations<br />
        C. LEGITIMATE BUSINESS INTERESTS<br />
        • System security and fraud prevention<br />
        • App improvement and analytics<br />
        • Customer support and technical assistance<br />
        • Business operations and HR administration<br />
        D. CONSENT (Where Required)<br />
        • Optional features like biometric attendance<br />
        • Marketing communications<br />
        • Data sharing with third-party service providers<br />
        • Photography for internal events and publications
      </div>

      <div>
        <p className="font-bold text-xl">4. Information Sharing and Disclosure</p><br />
        We share your information only in the following circumstances within India:<br />
        A. WITHIN YOUR ORGANIZATION<br />
        • Authorized HR personnel and management team<br />
        • Department heads and direct supervisors (role-appropriate data)<br />
        • IT administrators for system management and support<br />
        • Payroll and accounts team for salary processing<br />
        • Security personnel for access control and safety<br />
        B. STATUTORY AUTHORITIES AND GOVERNMENT AGENCIES<br />
        • Income Tax Department (for TDS and tax compliance)<br />
        • Provident Fund Organization (EPFO) for PF administration<br />
        • Employee State Insurance Corporation (ESIC) for medical benefits<br />
        • Labour Department and Labour Commissioner offices<br />
        • Registrar of Companies (ROC) for statutory filings<br />
        • Central/State Government agencies as required by law<br />
        C. AUTHORIZED SERVICE PROVIDERS (INDIA-BASED)<br />
        • Indian cloud hosting and data storage providers<br />
        • Payroll processing companies registered in India<br />
        • Banks for salary transfers and financial transactions<br />
        • CA firms for tax filing and statutory compliance<br />
        • IT support and maintenance providers<br />
        • Background verification agencies<br />
        D. LEGAL REQUIREMENTS<br />
        • Courts and judicial authorities pursuant to court orders<br />
        • Law enforcement agencies under valid legal process<br />
        • Regulatory bodies and compliance authorities<br />
        • Investigation agencies (CBI, ED, etc.) when legally required<br />
        E. BUSINESS TRANSFERS<br />
        • Mergers, acquisitions involving Indian entities<br />
        • Corporate restructuring within Indian jurisdiction<br />
        All third parties are required to maintain confidentiality and use information only for specified purposes under written agreements.
      </div>

      <div>
        <p className="font-bold text-xl">5. Data Security and Protection Measures</p><br />
        We implement comprehensive security measures as per Indian IT security standards:<br />
        A. TECHNICAL SAFEGUARDS<br />
        • ISO 27001 compliant security practices<br />
        • End-to-end encryption using AES-256 for data at rest<br />
        • TLS 1.3 encryption for data in transit<br />
        • Multi-factor authentication (OTP, biometric)<br />
        • Role-based access controls with approval workflows<br />
        • Regular security audits by Indian cybersecurity firms<br />
        • Intrusion detection and prevention systems<br />
        • Automated backup with 3-2-1 backup strategy<br />
        • Data masking and tokenization for sensitive information<br />
        B. ORGANIZATIONAL SAFEGUARDS<br />
        • Employee background verification through police verification<br />
        • Confidentiality and non-disclosure agreements<br />
        • Regular security awareness training programs<br />
        • Incident response team and escalation procedures<br />
        • Vendor security assessments and due diligence<br />
        • Clean desk and clear screen policies<br />
        • Segregation of duties and maker-checker controls<br />
        C. PHYSICAL SAFEGUARDS<br />
        • Secure data centers located within India<br />
        • Biometric access controls and CCTV surveillance<br />
        • 24/7 security personnel and monitoring<br />
        • Fire suppression systems and environmental controls<br />
        • Restricted access zones for critical infrastructure<br />
        • Visitor management and escort procedures<br />
        D. COMPLIANCE WITH INDIAN STANDARDS<br />
        • Information Security Management System (ISMS)<br />
        • Business Continuity Planning (BCP)<br />
        • Disaster Recovery (DR) with Indian backup locations<br />
        • Compliance with RBI guidelines (for financial data)<br />
        • CERT-In incident reporting procedures<br />
        Despite these comprehensive measures, no system is completely secure, and you acknowledge the inherent risks of electronic data transmission.
      </div>

      <div>
        <p className="font-bold text-xl">6. Data Retention and Disposal</p><br />
        We retain your personal information in accordance with Indian legal requirements:<br />
        A. ACTIVE EMPLOYMENT PERIOD<br />
        • All employment data maintained during active employment<br />
        • Real-time access for HR operations and statutory compliance<br />
        • Regular updates as per employment changes<br />
        B. POST-EMPLOYMENT RETENTION (As per Indian Laws)<br />
        • Personnel files: 10 years after termination (as per Industrial Disputes Act)<br />
        • Payroll and salary records: 10 years (as per Income Tax Act)<br />
        • PF records: Permanent retention (until final settlement)<br />
        • ESI records: 6 years after last contribution<br />
        • Bonus records: 6 years (as per Payment of Bonus Act)<br />
        • Gratuity records: 10 years (as per Payment of Gratuity Act)<br />
        • Leave records: 3 years after termination<br />
        • Training and performance records: 7 years<br />
        • Disciplinary and legal records: 10 years or duration of legal proceedings<br />
        C. STATUTORY DOCUMENT RETENTION<br />
        • Form 16 and tax documents: 8 years<br />
        • Bank account details: 10 years after account closure<br />
        • Loan and advance records: 10 years after full repayment<br />
        • Insurance records: 5 years after policy expiry<br />
        • Contract labour records: 5 years (as per Contract Labour Act)<br />
        D. AUTOMATIC DELETION<br />
        • Temporary files and cache: 48 hours<br />
        • Session logs: 90 days<br />
        • Biometric templates: Immediately after authentication<br />
        • Failed login attempts: 30 days<br />
        E. SECURE DISPOSAL<br />
        • Physical documents: Shredding with certificate of destruction<br />
        • Electronic data: Cryptographic erasure and overwriting<br />
        • Storage media: Physical destruction by authorized vendors<br />
        • Regular disposal audits and compliance verification<br />
        Extended retention may apply for legal proceedings, investigations, or specific statutory requirements.
      </div>

      <div>
        <p className="font-bold text-xl">7. Your Rights and Controls</p><br />
        Under Indian privacy laws and our policies, you have the following rights:<br />
        A. ACCESS AND TRANSPARENCY RIGHTS<br />
        • Access to your personal information held by us<br />
        • Information about data processing activities<br />
        • Details of data sharing with third parties<br />
        • Copy of your data in commonly used electronic format<br />
        B. CORRECTION AND UPDATE RIGHTS<br />
        • Correct inaccurate or incomplete personal information<br />
        • Update employment details, contact information<br />
        • Modify bank details and tax information<br />
        • Request correction of payroll and attendance records<br />
        C. WITHDRAWAL OF CONSENT<br />
        • Withdraw consent for optional biometric attendance<br />
        • Opt-out of internal marketing communications<br />
        • Refuse consent for photography and promotional materials<br />
        • Discontinue GPS-based location tracking (where optional)<br />
        D. DATA PORTABILITY<br />
        • Request your employment data in portable format<br />
        • Transfer service records to new employer<br />
        • Export salary slips, tax documents, and certificates<br />
        E. GRIEVANCE AND COMPLAINT RIGHTS<br />
        • File complaints about data processing practices<br />
        • Request investigation of privacy violations<br />
        • Appeal decisions regarding data requests<br />
        • Escalate unresolved issues to senior management<br />
        F. LIMITATION OF PROCESSING<br />
        • Request temporary suspension of data processing (where legally permissible)<br />
        • Object to certain types of data processing<br />
        • Restrict access to sensitive information<br />
        To exercise these rights, contact our Data Protection Officer at <a href="mailto:support@anstracknology.com">support@anstracknology.com</a> with proper identification. We will respond within 30 days of receiving your request.<br />
        Note: Some rights may be limited by legal obligations, employment law requirements, or legitimate business interests.
      </div>

      <div>
        <p className="font-bold text-xl">8. Children's Privacy Protection</p><br />
        AnsHR is designed exclusively for workplace use by employees aged 18 years and above. We do not knowingly collect personal information from individuals under 18 years of age.<br />
        In case of internship programs or apprenticeships:<br />
        • Parental consent is obtained for individuals under 18<br />
        • Limited data collection for educational and training purposes<br />
        • Special protection measures for minor's personal information<br />
        • Immediate deletion upon completion of program<br />
        If you believe we have collected information from a minor without proper authorization, please contact us immediately at <a href="mailto:support@anstracknology.com">support@anstracknology.com</a> for immediate rectification.
      </div>

      <div>
        <p className="font-bold text-xl">9. Biometric Data Processing</p><br />
        For organizations using biometric attendance systems within Indian jurisdiction:<br />
        A. COLLECTION AND PROCESSING<br />
        • Biometric data collection only with explicit written consent<br />
        • Fingerprint and facial recognition data for attendance purposes<br />
        • Local processing and encryption of biometric templates<br />
        • No storage of raw biometric images<br />
        B. SECURITY MEASURES<br />
        • Biometric data encrypted using advanced cryptographic methods<br />
        • Storage in secure, tamper-proof biometric devices<br />
        • Access restricted to authorized system administrators<br />
        • Regular security audits and vulnerability assessments<br />
        C. RETENTION AND DELETION<br />
        • Biometric templates deleted immediately after employment termination<br />
        • Raw biometric data never stored in central databases<br />
        • Secure disposal of biometric devices as per IT disposal guidelines<br />
        D. EMPLOYEE RIGHTS<br />
        • Right to withdraw consent for biometric attendance<br />
        • Alternative attendance methods for those who opt-out<br />
        • Access to biometric data processing logs<br />
        • Complaint mechanism for biometric data issues<br />
        E. COMPLIANCE<br />
        • Adherence to Supreme Court guidelines on biometric data<br />
        • Compliance with Aadhaar Act provisions (where applicable)<br />
        • Regular training for personnel handling biometric systems<br />
        • Documentation of biometric data processing activities
      </div>

      <div>
        <p className="font-bold text-xl">10. Cookies and Tracking Technologies</p><br />
        AnsHR uses cookies and similar technologies for legitimate business purposes:<br />
        A. ESSENTIAL COOKIES<br />
        • User authentication and session management<br />
        • Security features and fraud prevention<br />
        • Core app functionality and user preferences<br />
        • Language selection and accessibility settings<br />
        B. PERFORMANCE AND ANALYTICS COOKIES<br />
        • App usage statistics and performance monitoring<br />
        • Error tracking and system optimization<br />
        • User experience improvement and feature usage analysis<br />
        • System load balancing and resource optimization<br />
        C. FUNCTIONAL COOKIES<br />
        • Personalization and customized dashboard settings<br />
        • Remember user preferences and configuration<br />
        • Offline functionality and data synchronization<br />
        We do not use advertising or marketing cookies. All cookies are essential for app functionality or performance improvement.<br />
        Cookie Management:<br />
        • You can manage cookie preferences through device settings<br />
        • Disabling essential cookies may affect app functionality<br />
        • We respect browser "Do Not Track" settings where applicable<br />
        • Cookies are automatically deleted after session expiry or app uninstall
      </div>

      <div>
        <p className="font-bold text-xl">11. Third-Party Integrations and Services</p><br />
        AnsHR does not use any third-party integrations or external service providers for its core features. All employee data, payroll records, and HR information are processed and stored securely within AnsHR's system.<br />
        We only rely on essential internal tools to deliver a safe and efficient HR management experience, without sharing your information with outside vendors or partners.
      </div>

      <div>
        <p className="font-bold text-xl">12. Data Breach Response and Notification</p><br />
        AnsHR takes data security very seriously. In the unlikely event of a data breach:<br />
        • We will immediately secure our systems and investigate the issue.<br />
        • Affected users will be informed promptly with details of the incident.<br />
        • Necessary steps will be taken to prevent future occurrences.<br />
        • We will fully comply with applicable Indian data protection and legal requirements.<br />
        Our goal is to maintain transparency, protect your information, and restore services as quickly as possible.
      </div>

      <div>
        <p className="font-bold text-xl">13. Grievance Redressal</p><br />
        If you have any concerns, complaints, or questions about how your data is handled in AnsHR:<br />
        • You can contact our support team at <a href="mailto:support@anstracknology.com">support@anstracknology.com</a>.<br />
        • We aim to acknowledge all complaints within 48 hours.<br />
        • Our team will investigate and resolve issues as quickly as possible, usually within 30 days.<br />
        We are committed to addressing your concerns fairly, transparently, and without any retaliation.
      </div>

      <div>
        <p className="font-bold text-xl">14. Updates to Privacy Policy</p><br />
        We may update this Privacy Policy from time to time to reflect changes in law, business practices, or security improvements.<br />
        • Users will be notified of significant changes through in-app alerts or email.<br />
        • Minor updates take effect immediately upon posting.<br />
        • Major updates will be shared at least 30 days in advance.<br />
        Your continued use of AnsHR after changes indicates acceptance of the updated policy.
      </div>

      <div>
        <p className="font-bold text-xl">15. Compliance and Legal Framework</p><br />
        AnsHR complies with:<br />
        • Google Play and Apple App Store privacy requirements<br />
        • Indian IT Act, 2000 and applicable Rules<br />
        • Intermediary Guidelines, 2021<br />
        • Emerging Indian data protection laws<br />
        We follow best practices to ensure compliance with app store policies and Indian privacy regulations.
      </div>

      <div>
        <p className="font-bold text-xl">16. Legal Disclaimer</p><br />
        This Privacy Policy is governed by the laws of India.<br />
        While we implement strong security practices, no system is 100% secure. Users acknowledge risks in electronic data transmission.<br />
        Our liability is limited to the extent permitted by Indian law. Users are responsible for keeping their login credentials safe and reporting any suspected security issues promptly.
      </div>

      <div>
        <p className="font-bold text-xl">17. Contact Information</p><br />
        For privacy-related inquiries or complaints, you can reach us at:<br />
        📧 <a href="mailto:support@anstracknology.com">support@anstracknology.com</a><br />
        🌐 <a href="https://www.anstracknology.com">www.anstracknology.com</a><br />
        Address:<br />
        Ans Tracknology Private Limited<br />
        Gala no: 1 & 2 Surbhi Apartment Beside to Kanchan Gauri Bldg Near NES School Kasar Alley Bhiwandi Dist. Thane (MH) 421308<br />
        India<br />
        We are committed to responding to your concerns as quickly as possible.
      </div>
    </div>
  );
}
